export default __webpack_public_path__ + "static/media/2715.7ea17ded.svg";